// extracted by mini-css-extract-plugin
export default {"h6":"H6title_h6__MVr93","white":"H6title_white__ZvQp+"};